export default {"src":"/_next/static/media/flat-screen-tv.8565f739.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};